import './WorkPerformanceStatsTable.scss';
import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { SortingDirection } from '../../../../../../__legacy__/models/sortingDirection.model';
import { IProjectStatsFiltersStore } from '../../filters/ProjectStatsFilters.store';
import { IProjectStatsBl } from '../../ProjectStats.bl';
import { IProjectStatsStore } from '../../ProjectStats.store';
import { WorkPerformanceStatsTable } from './WorkPerformanceStatsTable';

export const WorkPerformanceStatsTableContainer = observer((): ReactElement => {
  const bl = useInjection(IProjectStatsBl.$);
  const filtersStore = useInjection(IProjectStatsFiltersStore.$);
  const store = useInjection(IProjectStatsStore.$);

  const handleOnSortChange = (orderBy: string, orderDirection: SortingDirection | undefined): void => {
    bl.changeWorkPerformanceStatsSorting(orderBy, orderDirection ?? SortingDirection.ASC);
  };

  const { visibleWorkers } = filtersStore;
  const { workPerformanceStats } = store;
  const items = workPerformanceStats.filter((s) => visibleWorkers.map((w) => w.id).includes(s.id));

  return (
    <WorkPerformanceStatsTable
      items={items}
      orderBy={store.workPerformanceStatsOrderBy}
      orderDirection={store.workPerformanceStatsOrderDirection}
      onSortChange={handleOnSortChange}
    />
  );
});
